import { Icon, Text, HStack } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { Box } from 'native-base';
import * as zod from 'zod';

export const validatePassword = (password?: string) => {
  const passwordLength = zod.string().min(8).max(15).safeParse(password).success;
  const containsSpecialChar = password?.length && /[!@$%*?]/.test(password);
  const containsUppercase = password?.length && /[A-Z]/.test(password);
  const containsLowercase = password?.length && /[a-z]/.test(password);
  const containsNumber = password?.length && /\d/.test(password);

  const validationResult = {
    passwordLength,
    containsSpecialChar,
    containsUppercase,
    containsLowercase,
    containsNumber,
  };

  const allValid = Object.values(validationResult).every(Boolean);

  return { success: allValid, validationResult };
};

export const passwordValidations = {
  passwordLength: 'Conter entre 8 e 15 caracteres',
  containsSpecialChar: 'Conter ao menos um dos caracteres especiais ( !, @, $, %, *, ?)',
  containsUppercase: 'Conter ao menos uma letra maiúscula',
  containsLowercase: 'Conter ao menos uma letra minúscula',
  containsNumber: 'Conter ao menos um número',
  passwordsMatch: 'As senhas devem coincidir',
};

export const validationIndicators = (password?: string, passwordConfirmation?: string) => {
  const passwordValidationResult = {
    ...validatePassword(password).validationResult,
    passwordsMatch: password && passwordConfirmation && password === passwordConfirmation,
  };

  return Object.entries(passwordValidationResult).map(([key, value]) => (
    <HStack key={key} alignItems="center">
      <Box width="24px" height="24px" alignItems="center" justifyContent="center">
        <Icon
          name={value ? 'Check' : 'Close'}
          size={value ? 'xxs' : 'xxxs'}
          color={Color[value ? 'feedback.success.default' : 'feedback.error.default']}
        />
      </Box>
      <Text flex={1}>{passwordValidations[key]}</Text>
    </HStack>
  ));
};
